/**
 * Copyright © 2024 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { gql } from '@apollo/client'

const DXO_EXECUTION_INTERVAL_FRAGMENT = gql`
  fragment DXOExecutionInterval on DXOExecutionInterval {
    date
    groupId
    numCompliant
    numPriorities
  }
`

export const GET_DXO_EXECUTION_INTERVAL_REPORT = gql`
  query GetDXOExecutionIntervalReport($input: DXOIntervalReportInput!) {
    dxoExecutionIntervalReport(input: $input) {
      ...DXOExecutionInterval
    }
  }
  ${DXO_EXECUTION_INTERVAL_FRAGMENT}
`
